import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import {
  DEFAULT_USER_AVATAR_URL,
  resolveUserAvatarDisplay,
} from './users-management-avatar';

@Component({
  selector: 'bo-users-management-user-avatar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AvatarModule],
  template: `
    @switch (display.mode) {
      @case ('image') {
        <p-avatar
          [image]="display.src"
          [shape]="shape"
          [size]="size"
          [styleClass]="styleClass"
          (onImageError)="onImageError()"
        />
      }
      @case ('initials') {
        <p-avatar [label]="display.label" [shape]="shape" [size]="size" [styleClass]="styleClass" />
      }
      @default {
        <p-avatar [image]="defaultUrl" [shape]="shape" [size]="size" [styleClass]="styleClass" />
      }
    }
  `,
  styleUrl: './users-management-user-avatar.component.scss',
})
export class UsersManagementUserAvatarComponent implements OnChanges {
  #cdr = inject(ChangeDetectorRef);

  @Input() avatar?: string | null;
  @Input() firstName?: string | null;
  @Input() lastName?: string | null;
  @Input() shape: 'circle' | 'square' = 'circle';
  @Input() size: 'normal' | 'large' | 'xlarge' = 'normal';
  @Input() styleClass = '';

  readonly defaultUrl = DEFAULT_USER_AVATAR_URL;

  imageFailed = false;

  get display() {
    return resolveUserAvatarDisplay({
      avatar: this.avatar,
      firstName: this.firstName,
      lastName: this.lastName,
      imageFailed: this.imageFailed,
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['avatar'] || changes['firstName'] || changes['lastName']) {
      this.imageFailed = false;
    }
  }

  onImageError(): void {
    this.imageFailed = true;
    this.#cdr.markForCheck();
  }
}
